
import React from 'react';
import { FeatureShowcase } from '@/components/subscription/FeatureShowcase';

export function DashboardPreview() {
  const benefits = [
    "Comprehensive learning progress tracking across all subjects",
    "Visual statistics and completion rates for your studies",
    "Achievement tracking and milestone celebrations",
    "Personalized recommendations based on your performance",
    "Integrated calendar with study schedules and reminders",
    "Quick access to all study tools and resources"
  ];
  
  const screenshots = [
    {
      url: "/lovable-uploads/871f51dc-3381-43a8-85dc-db55c930231a.png",
      caption: "Dashboard - Track your progress in one place"
    },
    {
      url: "/lovable-uploads/0b50a708-946c-4b43-b88f-ab13d1ced912.png",
      caption: "Analytics - Track your learning progress with detailed metrics"
    }
  ];

  return (
    <FeatureShowcase
      title="Smart Learning Dashboard"
      description="Track your progress, achievements, and get personalized recommendations all in one place."
      featureName="Dashboard"
      benefits={benefits}
      screenshots={screenshots}
    />
  );
}
